export default __webpack_public_path__ + "static/media/employees_5.4df9d246.png";